export default "__VITE_ASSET__BlLVBtDx__"